export function useSocket(channel, events = []) {
  const { $Echo } = useNuxtApp()

  const connection = ref(null)

  const connectedState = ref(null)

  watch(
    () => connection.value?.pusher?.connection?.state,
    () => onConnectionStateChange(connection.value.pusher.connection.state),
    { deep: true },
  )

  function onConnectionStateChange(state) {
    connectedState.value = state

    if (state === 'connecting' && !connection?.value?.pusher?.connection?.connecting) {
      connectedState.value = 'failed'
    }
  }

  function createConnection() {
    if ($Echo.instance) {
      connection.value = $Echo.instance.private(channel)

      connection.value.error((event) => console.log('error', event)) // eslint-disable-line

      connection.value.listenToAll((event, data) => (events?.[event] ? events[event] : () => {})(data))
    }
  }

  return {
    channel,
    connection,
    connectedState,
    createConnection,
  }
}
